module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "exportLocationsModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.LEX000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.clientList.length > 1) ? _c('div', {
    staticClass: "form-group fg-client-select"
  }, [_c('label', {
    staticClass: "col-md-2 control-label",
    attrs: {
      "for": "locationExportClientSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.LEX005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "locationExportClientSelect",
      "placeholder": _vm.lang.LEX005
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  })], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LEX001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised dialog-btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadExportData()
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.LEX002) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559ff9cf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LocationManagement/LocationExportModal.vue
// module id = 1679
// module chunks = 1